/** Minimum time to show "payment identified" before navigating away. */
export const PAYMENT_IDENTIFIED_DISPLAY_MS = 5000;

export function delayAfterPaymentIdentified(action: () => void, ms = PAYMENT_IDENTIFIED_DISPLAY_MS): () => void {
  const timer = window.setTimeout(action, ms);
  return () => window.clearTimeout(timer);
}
